import getApi from '../../api'
import { Profession } from '../../model/Professions'

export const getProfessions = () => getApi().get<Array<Profession>>('/professions')
